<template>
  <Loader v-if="loader && !listInDialog" />
  <Toast group="ticket" position="bottom-right" />
  <div :class="{ 'tickets-embedded': listInDialog }">
    <div class="filter-tickets mb-2" :class="{ 'filter-tickets--embedded': listInDialog }">
      <Accordion>
        <AccordionTab header="Filtri">
          <div v-if="listInDialog" class="filter-tickets-grid">
            <div class="filter-tickets-field">
              <label>Autore</label>
              <Dropdown v-model="selectedAuthor" :options="authors" optionLabel="name" optionValue="name" :filter="true"
                placeholder="Seleziona autore" class="inputfield w-full" />
            </div>
            <div class="filter-tickets-field">
              <label>Stato</label>
              <MultiSelect v-model="selectedStatus" :options="status" optionLabel="label" optionValue="label"
                :filter="true" placeholder="Seleziona stato" class="inputfield w-full" />
            </div>
            <div class="filter-tickets-field">
              <label>Reparto</label>
              <MultiSelect v-model="selectedDepartment" :options="departments" optionLabel="label" optionValue="label"
                :filter="true" placeholder="Seleziona reparto" class="inputfield w-full" />
            </div>
            <div class="filter-tickets-field">
              <label>Numero</label>
              <InputText v-model="selectedNumberId" type="search" placeholder="Inserisci numero" class="w-full" />
            </div>
            <div class="filter-tickets-actions">
              <p v-show="filterActive" class="p-error cursor-pointer m-0" @click="resetFilter">Rimuovi filtri</p>
              <Button label="Filtra" @click="filterTickets" />
            </div>
          </div>
          <div v-else class="formgrid grid ">
            <div class="field col-12 md:col-3">
              <label>Autore</label>
              <Dropdown v-model="selectedAuthor" :options="authors" optionLabel="name" optionValue="name" :filter="true"
                placeholder="Seleziona autore" class="inputfield w-full" />
            </div>
            <div class="field col-12 md:col-3">
              <label>Stato</label>
              <MultiSelect v-model="selectedStatus" :options="status" optionLabel="label" optionValue="label"
                :filter="true" placeholder="Seleziona stato" class="inputfield w-full" />
            </div>
            <div class="field col-12 md:col-3">
              <label>Reparto</label>
              <MultiSelect v-model="selectedDepartment" :options="departments" optionLabel="label" optionValue="label"
                :filter="true" placeholder="Seleziona reparto" class="inputfield w-full" />
            </div>
            <div class="field col-12 md:col-2">
              <label>Numero</label> <br>
              <InputText v-model="selectedNumberId" type="search" placeholder="Inserisci numero" class="w-full" />
            </div>
            <div class="field col-12 md:col-1 flex align-items-end">
              <Button label="Filtra" class="w-full" @click="filterTickets" />
            </div>
            <div class="field col-12 flex justify-content-end align-items-end">
              <p v-show="filterActive" class="p-error cursor-pointer" @click="resetFilter">Rimuovi filtri</p>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
    <div class="grid">
      <div :class="[listInDialog ? 'col-12' : 'col-5', 'tickets-sidebar']">
        <section class="discussions" :class="{ 'discussions--embedded': listInDialog, 'discussions--with-mail': mailTickets.length > 0 }">
          <div v-if="listLoading" class="discussions-loader">
            <span class="discussions-loader-spinner"></span>
          </div>
          <div class="discussion search" :class="{ 'search--embedded': listInDialog }">
            <div v-if="listInDialog" class="ticket-toolbar">
              <div class="searchbar">
                <i class="fa fa-search" aria-hidden="true"></i>
                <InputText @keyup="search" v-model="searchString" type="text" placeholder="Cerca..." />
              </div>
              <label class="ticket-toolbar-check" title="Con la spunta i ticket della tua area si vedono solo se assegnati a te. Senza spunta vedi tutti i ticket della tua area.">
                <Checkbox v-model="areaAssignedOnly" :binary="true" inputId="areaAssignedOnlyEmbedded" @change="onAreaAssignedOnlyChange" />
                <span>Assegnati a me</span>
              </label>
              <button type="button" class="ticket-toolbar-icon" title="Solo ticket non letti" @click="filterTickets(unread = !unread)">
                <i :class="['pi pi-eye ticket-unread-eye', unread ? 'text-primary' : '']" aria-hidden="true"></i>
                <span class="new-ticket-assigned">{{ unreadTicketsTotal }}</span>
              </button>
              <button type="button" class="ticket-toolbar-icon" title="Nuovo ticket" @click="dialogNewTicket = true">
                <i class="pi pi-plus-circle text-primary" aria-hidden="true"></i>
              </button>
            </div>
            <div v-else class="grid h-full mt-1">
              <div class="col-12 md:col-5 flex align-items-center justify-content-center pl-4">
                <div class="searchbar w-full">
                  <i class="fa fa-search" aria-hidden="true"></i>
                  <InputText @keyup="search" v-model="searchString" type="text" placeholder="Cerca..." />
                </div>
              </div>
              <div class="col-12 md:col-4 flex align-items-center">
                <Checkbox v-model="areaAssignedOnly" :binary="true" inputId="areaAssignedOnly" @change="onAreaAssignedOnlyChange" />
                <label for="areaAssignedOnly" class="area-assigned-only-label" title="Con la spunta i ticket della tua area si vedono solo se assegnati a te. Senza spunta vedi tutti i ticket della tua area.">
                  Assegnati a me
                </label>
              </div>
              <div class="col-12 md:col-2 flex align-items-center">
                <div class="new-ticket" @click="filterTickets(unread = !unread)" style="position:relative" title="Solo ticket non letti">
                  <i :class="['pi pi-eye ticket-unread-eye', unread ? 'text-primary' : '']" aria-hidden="true"></i>
                  <div class="new-ticket-assigned">{{ unreadTicketsTotal }}</div>
                </div>
              </div>
              <div class="col-12 md:col-1 flex align-items-center justify-content-center pr-4">
                <div class="new-ticket" @click="dialogNewTicket = true">
                  <i class="pi pi-plus-circle text-primary" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>

          <div v-if="normalTickets.length > 0">
            <div v-for="(ticket, index) in normalTickets" :key="ticket.id_ticket ?? index"
              :class="ticket.read == null ? 'ticket-not-read' : 'ticket-read'">
              <div @click="openTicket(ticket)"
                :class="['discussion', selectedTicket && selectedTicket.id_ticket == ticket.id_ticket ? 'message-active' : '']">
                <div class="id-number">
                  # {{ ticket.id_ticket }}
                  <span @click.stop="openLinkEntity(ticket)"
                    class="is-related cursor-pointer text-primary" v-if="ticket.id_entity != null"> • Legato a
                    {{ ticket.entity_type.toUpperCase() }}</span>
                </div>
                <div class="area">{{ ticket.area }}</div>
                <div class="creator"> {{ ticket.creator }}
                  <Chip class="type" :label="ticket.creator_type" />
                </div>
                <div class="badge-name" :style="`background-color:${randomColorFromString(ticket.creator)}`">
                  {{ getInitialOfName(ticket.creator) }}
                  <div v-if="getNumberMessagesUnread(ticket.messages) != 0" class="badge-number">
                    {{ getNumberMessagesUnread(ticket.messages) }}</div>
                  <div v-if="isAssignedToCurrentUser(ticket)" class="badge-assignment"><i
                      class="pi pi-tag"></i></div>
                </div>
                <div class="desc-contact">
                  <p class="name">{{ ticket.title }}</p>
                  <p class="message">{{ getContentLastMessage(ticket) }}</p>
                  <p v-if="isAssignedToUser(ticket)" class="assigned-line">
                    Assegnato a: {{ getAssignedLabel(ticket) }}
                  </p>
                </div>
                <div class="status">
                  <div class="icon" :style="`background-color:${ticket.color}`"></div>
                  <div class="text">{{ ticket.status }}</div>
                </div>
              </div>
            </div>
            <div class="pagination-container">
              <Paginator
                :first="(currentPage - 1) * perPage"
                :rows="perPage"
                :totalRecords="totalTickets"
                @page="onPageChange"
                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                currentPageReportTemplate="{first} a {last} di {totalRecords} ticket"
              />
            </div>
          </div>
          <div v-else>
            <div v-if="isLoaded" class="flex justify-content-center mt-4">
              Nessun ticket
            </div>
            <div v-else>
              <div v-for="(sk, ski) in Array.from({ length: 21 })" :key="ski" class="card m-2">
                <Skeleton class="mb-2"></Skeleton>
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="5rem" class="mb-2"></Skeleton>
              </div>
            </div>
          </div>
        </section>

        <!-- Sezione completamente separata: ticket email -->
        <section v-if="mailTickets.length > 0" class="mail-tickets-section" :class="{ 'mail-tickets-section--embedded': listInDialog }">
          <div class="mail-tickets-section__head">
            <div class="mail-tickets-section__title">
              <i class="pi pi-envelope"></i>
              <span>Ticket email</span>
            </div>
            <span class="mail-tickets-section__count">{{ mailTickets.length }}</span>
          </div>
          <div class="mail-tickets-section__list">
            <button
              v-for="(ticket, index) in mailTickets"
              :key="`mail-${ticket.id_ticket ?? index}`"
              type="button"
              class="mail-ticket-row"
              :class="{
                'mail-ticket-row--active': selectedTicket && selectedTicket.id_ticket == ticket.id_ticket,
                'mail-ticket-row--unread': ticket.read == null,
              }"
              @click="openTicket(ticket)"
            >
              <div class="mail-ticket-row__top">
                <span class="mail-ticket-row__id">#{{ ticket.id_ticket }}</span>
                <span class="mail-ticket-row__chip">EMAIL</span>
                <span class="mail-ticket-row__status" :style="{ backgroundColor: ticket.color }"></span>
                <span class="mail-ticket-row__status-label">{{ ticket.status }}</span>
              </div>
              <div class="mail-ticket-row__title">{{ ticket.title }}</div>
              <div class="mail-ticket-row__meta">
                <span>{{ ticket.creator }}</span>
                <span v-if="ticket.area">· {{ ticket.area }}</span>
              </div>
              <div class="mail-ticket-row__excerpt">{{ getContentLastMessage(ticket) }}</div>
            </button>
          </div>
        </section>
      </div>
      <div v-if="!listInDialog" class="col-7" style="position:relative">
        <TicketChatPanel v-if="selectedTicket && 'id_ticket' in selectedTicket" />
        <section v-else class="chat flex justify-content-center align-items-center h-full">
          Seleziona il ticket per leggere la conversazione
        </section>
      </div>
    </div>

    <Dialog
      v-if="listInDialog"
      v-model:visible="dialogTicketChat"
      :header="ticketDialogTitle"
      :breakpoints="{ '960px': '95vw', '640px': '100vw' }"
      :style="{ width: '85vw', maxWidth: '1100px' }"
      :modal="true"
      class="ticket-chat-dialog"
      @hide="onTicketDialogHide"
    >
      <div class="ticket-chat-dialog-body">
        <TicketChatPanel in-dialog />
      </div>
    </Dialog>


  </div>


  <!-- Dialog new ticket -->
  <Dialog header="Nuovo Ticket" v-model:visible="dialogNewTicket" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '70vw' }" :modal="true">
    <div class="formgrid grid mt-3">
      <div class="field col-12">
        <Dropdown v-model="newTicket.type_recipient" :options="typesRecipients" optionLabel="code" optionValue="name"
          :filter="true" @change="onChangeTypeRecipient" placeholder="Seleziona tipo destinatario"
          class="appearance-none outline-none focus:border-primary w-full" />
        <div v-show="validationErrors.type_recipient && submitted" class="p-error">Seleziona campo.</div>
      </div>

      <div v-if="newTicket.type_recipient != ''" class="field col-12">
        <AutoComplete v-model="newTicket.recipient" field="label" :dropdown="true" :minLength="3"
          :suggestions="recipients" @complete="getTicketRecipients($event, newTicket.type_recipient)"
          placeholder="Cerca..." class="appearance-none outline-none focus:border-primary w-full" />
        <div v-show="validationErrors.recipient && submitted" class="p-error">Seleziona campo.</div>
      </div>

      <div class="field col-12">
        <InputText v-model="newTicket.title" placeholder="Titolo del ticket..." class="w-full" />
        <div v-show="validationErrors.title && submitted" class="p-error">Seleziona campo.</div>
      </div>
      <div class="field col-12">
        <Textarea v-model="newTicket.content" rows="6" class="w-full" placeholder="Testo del ticket..." />
        <div v-show="validationErrors.content && submitted" class="p-error">Seleziona campo.</div>
      </div>

      <div class="field col-12 md:col-6">
        <label class="block mb-2">Trasferimento chiamata</label>
        <Dropdown
          v-model="newTicket.callTransferSuccess"
          :options="callTransferOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Non specificato"
          class="w-full"
          @change="onCallTransferSuccessChange"
        />
      </div>

      <div v-if="requiresCallTransferArea(newTicket.callTransferSuccess)" class="field col-12 md:col-6">
        <label class="block mb-2">Area verso cui hai provato a trasferire</label>
        <Dropdown
          v-model="newTicket.callTransferAreaId"
          :options="ticketAreas"
          optionLabel="area"
          optionValue="id_ticket_area"
          :filter="true"
          placeholder="Seleziona area..."
          class="w-full"
        />
        <div v-show="validationErrors.callTransferArea && submitted" class="p-error">
          Seleziona l'area verso cui hai provato a trasferire la chiamata.
        </div>
      </div>

      <div class="field col-12 flex align-items-center">
        <Checkbox v-model="newTicket.is_related" :binary="true" />
        <label class="ml-2"> Collegare il ticket a un pod,pdr,fattura... </label>
      </div>
      <span v-if="newTicket.is_related" class="w-full">
        <div class="field col-12">
          <Dropdown v-model="newTicket.type_entity" :options="typesEntity" optionLabel="type"
            @change="newTicket.entity = null" placeholder="Seleziona..."
            class="appearance-none outline-none focus:border-primary w-full" />
          <div v-show="validationErrors.type_entity && submitted" class="p-error">Seleziona campo.</div>
        </div>
        <div v-if="newTicket.type_entity != ''" class="field col-12">
          <AutoComplete v-model="newTicket.entity" field="label" :dropdown="true" :minLength="4" :suggestions="entity"
            @complete="getTicketEntity($event, newTicket.type_entity)" placeholder="Cerca..."
            class="appearance-none outline-none focus:border-primary w-full" />
          <div v-show="validationErrors.entity && submitted" class="p-error">Seleziona campo.</div>
        </div>
        <div class="field col-12">

        </div>
      </span>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogNewTicket = false" class="p-button-text" />
      <Button label="Crea" icon="pi pi-check" @click="createNewTicket" autofocus />
    </template>
  </Dialog>

  <!-- Dialog assignment to -->
  <Dialog header="Assignment" v-model:visible="dialogAssignment" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '70vw' }" :modal="true">
    <div class="w-full">
      <div class="field col-12">

        <Dropdown v-model="type_assign_recipient" :options="typesRecipients" optionLabel="code" optionValue="name"
          :filter="true" @change="onChangeTypeRecipient" placeholder="Seleziona tipo destinatario"
          class="appearance-none outline-none focus:border-primary w-full" />
      </div>
      <div v-if="type_assign_recipient != ''" class="field col-12">
        <AutoComplete v-model="selectedAssignUser" field="label" :dropdown="true" :minLength="3"
          :suggestions="recipients" @complete="getTicketRecipients($event, type_assign_recipient)"
          placeholder="Cerca..." class="appearance-none outline-none focus:border-primary w-full" />
      </div>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogAssignment = false" class="p-button-text" />
      <Button label="Assegna" icon="pi pi-check" @click="assignTicket" autofocus />
    </template>
  </Dialog>

  <!-- Dialog history status -->
  <Dialog header="History Status" v-model:visible="dialogHistoryStatus"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }" :modal="true">
    <div class="w-full">
      <DataTable :value="selectedTicket.history_status" responsiveLayout="scroll">
        <Column field="name" header="Nome"></Column>
        <Column field="datetime" header="Data">
          <template #body="{ data }">
            {{ moment(data.datetime).format('DD MMM YYYY HH:mm') }}
          </template>
        </Column>
        <Column field="status" header="Stato"></Column>
      </DataTable>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogHistoryStatus = false" class="p-button-text" />
    </template>
  </Dialog>

  <!-- Dialog assignment status -->
  <Dialog header="History Assignment" v-model:visible="dialogHistoryAssignment"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }" :modal="true">
    <div class="w-full">
      <DataTable :value="selectedTicket.history_assignment" responsiveLayout="scroll">
        <Column field="user_from" header="Da"></Column>
        <Column header="A">
          <template #body="{ data }">
            <p v-if="data.TYPE == 'AREA'">
              {{ data.area_to }}
            </p>
            <p v-else>
              {{ data.user_to }}
            </p>
          </template>
        </Column>
        <Column field="datetime" header="Data">
          <template #body="{ data }">
            {{ moment(data.datetime).format('DD MMM YYYY HH:mm') }}
          </template>
        </Column>
      </DataTable>
    </div>
    <template #footer>
      <Button label="Chiudi" icon="pi pi-times" @click="dialogHistoryAssignment = false" class="p-button-text" />
    </template>
  </Dialog>

  <Dialog
    header="Blocca sospensione"
    v-model:visible="dialogBloccaSospensione"
    :breakpoints="{ '960px': '60vw', '640px': '90vw' }"
    :style="{ width: '35vw' }"
    :modal="true"
  >
    <div class="w-full">
      <p class="m-0" v-if="isCheckingContestazione">
        Controllo in corso{{ numeroFatturaContestazione ? ` per la fattura ${numeroFatturaContestazione}` : '' }}...
      </p>

      <p class="m-0" v-else-if="contestazioneCheckResult && contestazioneCheckResult.success && contestazioneCheckResult.has_contestazione">
        Fattura già contestata{{ numeroFatturaContestazione ? ` (${numeroFatturaContestazione})` : '' }}.
      </p>

      <p class="m-0" v-else-if="contestazioneCheckResult && contestazioneCheckResult.success && !contestazioneCheckResult.has_contestazione">
        Fattura non contestata{{ numeroFatturaContestazione ? ` (${numeroFatturaContestazione})` : '' }}. Vuoi bloccare la sospensione?
      </p>

      <p class="m-0" v-else>
        {{ (contestazioneCheckResult && contestazioneCheckResult.message) ? contestazioneCheckResult.message : 'Impossibile verificare la fattura' }}
      </p>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        :disabled="isBlockingSospensione || isCheckingContestazione"
        @click="dialogBloccaSospensione = false"
      />
      <Button
        label="Conferma"
        icon="pi pi-check"
        class="p-button-danger"
        v-if="contestazioneCheckResult && contestazioneCheckResult.success && !contestazioneCheckResult.has_contestazione"
        :disabled="isCheckingContestazione"
        :loading="isBlockingSospensione"
        @click="confirmBloccaSospensione"
        autofocus
      />
    </template>
  </Dialog>

</template>

<script>

import moment from 'moment'
import { useStore } from 'vuex'
import { ref, onMounted, getCurrentInstance, nextTick, onUnmounted, computed, provide } from 'vue';
import Service from '@/services/ask-ticket/ticket-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import TicketChatPanel from '@/components/tickets/TicketChatPanel.vue'
import { useToast } from "primevue/usetoast";
// import Editor from 'primevue/editor';
import Cookies from "js-cookie";
const sendMessageSound = require("@/assets/sound/send-message.mp3");

export default {
  components: {
    Loader,
    TicketChatPanel,
    // Editor
  },

  props: {
    listInDialog: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {

    moment.locale('it');
    const loader = ref(false)
    const listLoading = ref(false)
    let ticketsRequestId = 0
    const isLoaded = ref(false)
    const toast = useToast();
    const store = useStore()
    const currentUser = ref(JSON.parse(atob(store.state.auth.user)))
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const sendMessageAudio = new Audio(sendMessageSound)
    const dialogNewTicket = ref(false)
    const dialogAssignment = ref(false)
    const dialogHistoryStatus = ref(false)
    const dialogHistoryAssignment = ref(false)
    const dialogBloccaSospensione = ref(false)
    const dialogTicketChat = ref(false)
    const isBlockingSospensione = ref(false)
    const isCheckingContestazione = ref(false)
    const contestazioneCheckResult = ref(null)
    const recipients = ref([])
    const typesRecipients = ref([
      { name: 'agente', code: 'Agente' },
      { name: 'client', code: 'Cliente' },
      { name: 'rappresentante', code: 'Rappresentante' },
      { name: 'assicuratori', code: 'Assicuratore' },
      { name: 'user', code: 'User' },
      { name: 'area', code: 'Area User' },
    ])
    const selectedAssignUser = ref(null)
    const newTicket = ref({
      title: '',
      content: '',
      recipient: null,
      type_recipient: '',
      type_entity: '',
      entity: '',
      is_related: false,
      callTransferSuccess: null,
      callTransferAreaId: null,
    })
    const ticketAreas = ref([])
    const replyCallTransferSuccess = ref(null)
    const replyCallTransferAreaId = ref(null)
    const callTransferOptions = [
      { label: 'Non specificato', value: null },
      { label: 'Sì, trasferimento riuscito', value: true },
      { label: 'No, trasferimento non riuscito', value: false },
    ]
    const recipientsAssignUser = ref([])
    const tickets = ref([])
    const originalTickets = ref([])
    const mailTicketsList = ref([])

    // const ticketsFiltered = computed(() => {
    //   return (tickets.value || []).filter((t) => {
    //     const title = String(t?.title ?? '').trim()
    //     return !title.startsWith('Nuova Pratica')
    //   })
    // })
    // const totalTickets = computed(() => {
    //   return tickets.value.length
    // })
    const selectedTicket = ref(null)
    const currentPage = ref(1)
    const perPage = ref(10)
    const totalTickets = ref(0)
    const unreadTicketsTotal = ref(0)
    const newMessage = ref('')
    const isSending = ref(false)
    const searchString = ref('')
    const authors = ref([])
    const filterActive = ref(false)
    let searchTimeout = null
    const selectedNumberId = ref(null)
    const selectedAuthor = ref(null)
    const selectedStatus = ref(null)
    const selectedDepartment = ref(null)
    const validationErrors = ref({})
    const submitted = ref(false)
    const status = ref([])
    const departments = ref([])
    const filesToUpload = ref([])
    var interval = null
    const keyReset = ref(0)
    const unread = ref(false)
    const assign = ref(false)
    const areaAssignedOnly = ref(true)
    const type_assign_recipient = ref('')
    const typesEntity = ref([])
    const entity = ref([])
    const allowedType = {
      'pdf': 'application/pdf',
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'csv': 'text/csv',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }



    onMounted(() => {
      getTickets()
      loadTicketAreas()

      if (!props.listInDialog) {
        interval = setInterval(() => {
          getTickets(false, true)
        }, 120000);
      }
      getStatus()
      getTypesEntity()
      // getTicketRecipients()
    })

    onUnmounted(() => {
      clearInterval(interval);
      
      if (searchTimeout) {
        clearTimeout(searchTimeout)
      }
    })


    self.$eventBus.on('update-numbers-message', () => {
      if (props.listInDialog) {
        return
      }
      getTickets(false)
    })


    const getTicketRecipients = (event, type) => {
      service.getTicketRecipients(event.query, type)
        .then((res) => {
          recipients.value = res.items;
        })
    }

    const getTypesEntity = () => {
      service.getTypesEntity()
        .then((res) => {
          typesEntity.value = res.items;
        })
    }


    const getTicketEntity = (event, type) => {
      service.getTicketEntity(event.query, type)
        .then((res) => {
          entity.value = res.items;
        })
    }

    const loadTicketAreas = () => {
      service.getTypesAreaTicket()
        .then((res) => {
          ticketAreas.value = res.items || []
        })
    }

    const requiresCallTransferArea = (value) => {
      return value === true || value === false
    }

    const onCallTransferSuccessChange = () => {
      if (!requiresCallTransferArea(newTicket.value.callTransferSuccess)) {
        newTicket.value.callTransferAreaId = null
      }
    }

    const onReplyCallTransferSuccessChange = () => {
      if (!requiresCallTransferArea(replyCallTransferSuccess.value)) {
        replyCallTransferAreaId.value = null
      }
    }

    const resetReplyCallTransfer = () => {
      replyCallTransferSuccess.value = null
      replyCallTransferAreaId.value = null
    }

    const resetNewTicketCallTransfer = () => {
      newTicket.value.callTransferSuccess = null
      newTicket.value.callTransferAreaId = null
    }

    const getCallTransferSuccess = (item) => {
      if (!item) return null

      if (item.call_transfer_success !== undefined && item.call_transfer_success !== null && item.call_transfer_success !== '') {
        return item.call_transfer_success === true
          || item.call_transfer_success === 1
          || item.call_transfer_success === '1'
      }

      if (item.call_transfer?.success !== undefined && item.call_transfer?.success !== null && item.call_transfer?.success !== '') {
        return !!item.call_transfer.success
      }

      return null
    }

    const getTicketAreaNameById = (areaId) => {
      if (!areaId) return ''
      const area = ticketAreas.value.find((entry) => entry.id_ticket_area === areaId)
      if (!area) return ''
      return area.area || area.code || ''
    }

    const getCallTransferAreaLabel = (item) => {
      if (!item) return ''

      return item.call_transfer_area_name
        || item.call_transfer_area
        || item.area_call_transfer
        || getTicketAreaNameById(item.id_call_transfer_area)
        || getTicketAreaNameById(item.call_transfer?.id_ticket_area)
        || ''
    }

    const hasCallTransferInfo = (item) => {
      return getCallTransferSuccess(item) !== null
    }

    const getTicketCallTransferLabel = (item) => {
      const success = getCallTransferSuccess(item)
      if (success === null) return ''

      const area = getCallTransferAreaLabel(item)
      if (success) {
        return area ? `Trasferimento riuscito verso ${area}` : 'Trasferimento riuscito'
      }

      return area ? `Trasferimento non riuscito verso ${area}` : 'Trasferimento non riuscito'
    }

    const getCallTransferBadgeClass = (item) => {
      const success = getCallTransferSuccess(item)
      if (success === true) return 'call-transfer-badge call-transfer-badge--success'
      if (success === false) return 'call-transfer-badge call-transfer-badge--failed'
      return 'call-transfer-badge'
    }

    const buildReplyCallTransferPayload = () => {
      if (!requiresCallTransferArea(replyCallTransferSuccess.value)) {
        return null
      }

      return {
        success: replyCallTransferSuccess.value === true,
        id_ticket_area: replyCallTransferAreaId.value,
      }
    }

    const buildCreateTicketPayload = () => {
      const {
        callTransferSuccess,
        callTransferAreaId,
        ...payload
      } = newTicket.value

      if (requiresCallTransferArea(callTransferSuccess)) {
        payload.call_transfer = {
          success: callTransferSuccess === true,
          id_ticket_area: callTransferAreaId,
        }
      }

      return payload
    }

    const getStatus = () => {
      loader.value = true
      service.getStatus().then((res) => {
        let statusObj = []
        res.items.forEach(el => {
          let obj = {}
          obj.label = el.status
          obj.val = el.id_ticket_status
          obj.command = () => {
            changeStatus(el.id_ticket_status)
          }
          statusObj.push(obj)
        });
        status.value = statusObj
      })
        .finally(() => {
          loader.value = false
        })
    }

    const buildFilters = () => {
      const filters = {}
      
      if (searchString.value && searchString.value.length > 0) {
        filters.search = searchString.value
      }
      if (selectedAuthor.value) {
        filters.author = selectedAuthor.value
      }
      if (selectedStatus.value && selectedStatus.value.length > 0) {
        filters.status = selectedStatus.value
      }
      if (selectedDepartment.value && selectedDepartment.value.length > 0) {
        filters.department = selectedDepartment.value
      }
      if (selectedNumberId.value) {
        filters.numberId = selectedNumberId.value
      }
      if (unread.value) {
        filters.unread = true
      }
      if (assign.value) {
        filters.assigned = currentUser.value.user[0].id
      }
      filters.areaAssignedOnly = areaAssignedOnly.value
      
      console.log('Filtri inviati al backend:', filters)
      return filters
    }

    const getTickets = async (refresh = true, scroll = false, options = {}) => {
      const { localOnly = false } = options
      const useLocalLoader = localOnly || props.listInDialog

      isLoaded.value = false
      if (refresh) {
        if (useLocalLoader) {
          listLoading.value = true
          loader.value = false
        } else {
          loader.value = true
          listLoading.value = false
        }
      }

      const filters = buildFilters()
      const normalFilters = { ...filters, mail_scope: 'exclude', includeMail: false }
      const requestId = ++ticketsRequestId
      const mailPromise = props.listInDialog
        ? null
        : service.getTickets(1, 50, { ...filters, mail_scope: 'only' })

      const keepOpenTicket = () => {
        if (refresh != false || selectedTicket.value == null) return
        const id = selectedTicket.value.id_ticket
        const refreshed = [...originalTickets.value, ...mailTicketsList.value]
          .find((el) => el.id_ticket == id)
        if (refreshed) {
          const prev = selectedTicket.value
          selectedTicket.value = {
            ...refreshed,
            mail_thread: Array.isArray(prev.mail_thread) ? prev.mail_thread : [],
            mail_thread_loading: Boolean(prev.mail_thread_loading),
            is_mail: prev.is_mail || refreshed.is_mail,
          }
        }
        if (scroll == true) {
          document.getElementById('scroll-last')?.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'start' })
        }
      }

      try {
        const normalRes = await service.getTickets(currentPage.value, perPage.value, normalFilters)
        if (requestId !== ticketsRequestId) return

        tickets.value = normalRes.items || []
        originalTickets.value = normalRes.items || []
        if (props.listInDialog) {
          mailTicketsList.value = []
        }

        if (normalRes.pagination) {
          totalTickets.value = normalRes.pagination.total
          currentPage.value = normalRes.pagination.current_page
        }
        unreadTicketsTotal.value = normalRes.unreadTotal ?? (filters.unread ? (normalRes.pagination?.total ?? 0) : unreadTicketsTotal.value)

        populateAuthors()
        populateDepartments()
        self.$eventBus.emit('update-numbers-ticket')
        keepOpenTicket()
      } finally {
        if (requestId === ticketsRequestId) {
          isLoaded.value = true
          loader.value = false
          listLoading.value = false
        }
      }

      if (!mailPromise) return
      mailPromise.then((mailRes) => {
        if (requestId !== ticketsRequestId) return
        mailTicketsList.value = (mailRes.items || []).map((t) => ({ ...t, is_mail: true }))
        keepOpenTicket()
      }).catch(() => {})
    }

    const onPageChange = (event) => {
      currentPage.value = (event.first / event.rows) + 1
      perPage.value = event.rows
      getTickets(true, false, { localOnly: true })
    }



    const createNewTicket = () => {
      submitted.value = true

      if (validateNewTicket()) {
        loader.value = true
        service.createTicket(buildCreateTicketPayload()).then((res) => {
          if (res.success == true) {
            toast.add({ severity: 'success', summary: 'Successo', detail: 'Ticket creato', group: 'ticket', life: 3000 });
            dialogNewTicket.value = false
            newTicket.value.title = ''
            newTicket.value.content = ''
            newTicket.value.recipient = null
            resetNewTicketCallTransfer()
          } else {
            toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore nella creazione del ticket', group: 'ticket' });
          }
        }).finally(() => {
          getTickets(false)
          loader.value = false
        })
      }
    }

    const sendMessage = () => {
      if (isMailTicket(selectedTicket.value)) {
        return
      }
      if (newMessage.value.length > 0) {
        if (filesToUpload.value.length > 0) {
          if (!validateFiles()) {
            return
          }
        }

        if (
          requiresCallTransferArea(replyCallTransferSuccess.value)
          && !replyCallTransferAreaId.value
        ) {
          toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Seleziona l\'area verso cui hai provato a trasferire la chiamata',
            group: 'ticket',
            life: 3000,
          })
          return
        }

        isSending.value = true
        const idAssignedUser = selectedTicket.value.id_assigned_user || null;
        const callTransfer = buildReplyCallTransferPayload()

        service.sendMessage(
          selectedTicket.value.id_ticket,
          newMessage.value,
          filesToUpload.value,
          idAssignedUser,
          { callTransfer },
        )
          .then((res) => {
            if (res?.data?.success == true) {
              playAudio(sendMessageAudio)
              getTickets(false, true)
              newMessage.value = ''
              filesToUpload.value = []
              keyReset.value = new Date()
              resetReplyCallTransfer()
              isSending.value = false
            } else {
              toast.add({
                severity: 'warn',
                summary: 'Attenzione',
                detail: res?.data?.message || 'Errore nell\' invio del messaggio',
                group: 'ticket',
                life: 6000,
              });
            }
          }).finally(() => {
            isSending.value = false
          })
      } else {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Il messaggio non può essere vuoto', group: 'ticket', life: 3000 });
      }
    }

    const playAudio = (audio) => {
      if (Cookies.get('sound') && Cookies.get('sound') == 1) {
        audio.play();
      }
    }

    const isAssignedToUser = (ticket) => {
      if (!ticket?.id_assigned_user) return false
      return String(ticket.assigned_user_type || '').toLowerCase().trim() === 'user'
    }

    const isAssignedToCurrentUser = (ticket) => {
      const userId = currentUser.value?.user?.[0]?.id
      if (!isAssignedToUser(ticket) || !userId) return false
      return String(ticket.id_assigned_user) === String(userId)
    }

    const getAssignedLabel = (ticket) => {
      if (!isAssignedToUser(ticket)) return ''
      const name = String(ticket.assigned_user_name || '').trim()
      return name || 'Utente assegnato'
    }

    const getContentLastMessage = (ticket) => {
      if (Object.keys(ticket.messages).length > 0) {
        let lastDate = Object.keys(ticket.messages)[Object.keys(ticket.messages).length - 1];
        let lastMessageContent = (ticket.messages[lastDate].slice(-1))[0].content
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = lastMessageContent;
        let textContent = tempDiv.textContent || tempDiv.innerText || "";
        return (textContent.slice(0, 50)) + "..."
      }
      return ''
    }

    const getInitialOfName = (creator) => {
      if (creator && creator.length > 0) {
        return creator.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);
      }
      return 'ND'
    }

    const scrollChatToUnreadOrBottom = (rootEl) => {
      const container = rootEl || document
      const nMessageUnread = getNumberMessagesUnread(selectedTicket.value.messages)
      const div = document.getElementsByClassName('box-unread')
      if (div.length > 0) {
        div[0].parentNode.removeChild(div[0])
      }

      nextTick(() => {
        const scrollLast = container.querySelector('#scroll-last')
        if (nMessageUnread == 0) {
          scrollLast?.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'start' })
        } else {
          const el = container.querySelector('.message-not-read')
          if (el) {
            const elem = document.createElement('div')
            elem.className = 'box-unread'
            elem.innerText = 'Messaggi non letti'
            el.parentNode.insertBefore(elem, el)
            el.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'start' })
            setMessageAsRead(selectedTicket.value)
          }
        }
      })
    }

    const ticketDialogTitle = computed(() => {
      if (!selectedTicket.value || !('id_ticket' in selectedTicket.value)) {
        return 'Ticket'
      }
      const ticket = selectedTicket.value
      const title = ticket.title || ticket.area || 'Ticket'
      return `#${ticket.id_ticket} — ${title}`
    })

    const onTicketDialogHide = () => {
      dialogTicketChat.value = false
    }

    const openTicket = async (ticket) => {
      selectedTicket.value = {
        ...ticket,
        mail_thread: Array.isArray(ticket?.mail_thread) ? ticket.mail_thread : [],
        mail_thread_loading: false,
      }
      resetReplyCallTransfer()

      if (isMailTicket(ticket)) {
        loadMailThread(ticket.id_ticket)
      }

      if (props.listInDialog) {
        dialogTicketChat.value = true
        nextTick(() => {
          const root = document.querySelector('.ticket-chat-dialog-body')
          scrollChatToUnreadOrBottom(root)
        })
        return
      }

      scrollChatToUnreadOrBottom(document)
    }

    const isMailTicket = (ticket) => {
      if (!ticket) return false
      if (ticket.is_mail === true || ticket.is_mail === 1 || ticket.is_mail === '1') return true
      if (Array.isArray(ticket.mail_thread) && ticket.mail_thread.length > 0) return true
      const area = String(ticket.area || ticket.areaCode || '').toLowerCase()
      return area === 'mail' || area.includes('mail')
    }

    const normalTickets = computed(() => tickets.value || [])
    const mailTickets = computed(() => mailTicketsList.value || [])

    const loadMailThread = async (idTicket) => {
      if (!idTicket || !selectedTicket.value || selectedTicket.value.id_ticket != idTicket) return

      selectedTicket.value = {
        ...selectedTicket.value,
        mail_thread_loading: true,
      }

      try {
        const res = await service.getMailThread(idTicket)
        if (!selectedTicket.value || selectedTicket.value.id_ticket != idTicket) return

        const payload = res?.data || {}
        selectedTicket.value = {
          ...selectedTicket.value,
          is_mail: payload.is_mail ?? selectedTicket.value.is_mail,
          mail_thread: Array.isArray(payload.mail_thread) ? payload.mail_thread : [],
          mail_thread_loading: false,
        }
      } catch (err) {
        console.error('Errore loadMailThread:', err)
        if (selectedTicket.value && selectedTicket.value.id_ticket == idTicket) {
          selectedTicket.value = {
            ...selectedTicket.value,
            mail_thread_loading: false,
          }
        }
      }
    }

    const extractNumeroFatturaFromTicket = (ticket) => {
      if (!ticket) return null
      const candidates = [
        ticket.numero_fattura,
        ticket.numeroFattura,
        ticket.numero,
        ticket.number_id,
        ticket.numberId,
        ticket.id_entity,
      ]

      const found = candidates.find((v) => v !== null && v !== undefined && String(v).trim() !== '')
      if (found !== undefined) {
        return String(found).trim()
      }

      const title = String(ticket.title || '').trim()
      if (title) {
        const patterns = [
          /contestazione\s+fattura\s+n\.?\s*([a-z0-9-]+)\b/i,
          /fattura\s+n\.?\s*([a-z0-9-]+)\b/i,
          /\b([a-z]\d{6,})\b/i,
          /\b(\d{6,})\b/i,
        ]

        for (const re of patterns) {
          const match = title.match(re)
          if (match && match[1]) {
            return String(match[1]).trim().toUpperCase()
          }
        }
      }

      return null
    }

    const shouldShowBloccaSospensione = computed(() => {
      if (!selectedTicket.value) return false
      return Number(selectedTicket.value.contestazione) === 1
    })

    const numeroFatturaContestazione = computed(() => {
      return extractNumeroFatturaFromTicket(selectedTicket.value)
    })

    const openCheckSospensioneDialog = async () => {
      const numeroFattura = extractNumeroFatturaFromTicket(selectedTicket.value)
      if (!numeroFattura) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Numero fattura mancante sul ticket',
          group: 'ticket',
          life: 3000,
        })
        return
      }

      contestazioneCheckResult.value = null
      dialogBloccaSospensione.value = true
      isCheckingContestazione.value = true
      try {
        const { item } = await service.checkContestazioneFromTicket(numeroFattura)
        contestazioneCheckResult.value = item
      } finally {
        isCheckingContestazione.value = false
      }
    }

    const confirmBloccaSospensione = async () => {
      const numeroFattura = extractNumeroFatturaFromTicket(selectedTicket.value)

      if (!numeroFattura) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Numero fattura mancante sul ticket',
          group: 'ticket',
          life: 3000,
        })
        dialogBloccaSospensione.value = false
        return
      }

      isBlockingSospensione.value = true
      try {
        const { item } = await service.addContestazioneFromTicket(numeroFattura)
        if (item && item.success) {
          toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Blocco sospensione eseguito',
            group: 'ticket',
            life: 3000,
          })
          dialogBloccaSospensione.value = false
          getTickets(false)
        } else {
          toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: (item && item.message) ? item.message : 'Errore durante blocco sospensione',
            group: 'ticket',
            life: 4000,
          })
        }
      } finally {
        isBlockingSospensione.value = false
      }
    }


    const setMessageAsRead = (ticket) => {
      let messagesUnread = [];
      if (Object.keys(ticket.messages).length > 0) {
        for (const elData of Object.values(ticket.messages)) {
          elData.filter(el => {
            if (el.read == null) {
              messagesUnread.push(el)
            }
          })
        }
        service.setMessageAsRead(messagesUnread).then((res) => {
          if (!res.data) {
            toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore nel segnare come letti i messaggi', group: 'ticket' });
          } else {
            getTickets(false)
            self.$eventBus.emit('update-numbers-ticket');
          }
        })
      }

    }

    const search = () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout)
      }
      
      if (!searchString.value || searchString.value.trim() === '') {
        console.log('Ricerca vuota - ricarico senza filtri')
        currentPage.value = 1
        getTickets(true, false)
        return
      }
      
      searchTimeout = setTimeout(() => {
        console.log('Ricerca per:', searchString.value)
        currentPage.value = 1
        getTickets(true, false)
      }, 500)
    };



    const onAreaAssignedOnlyChange = () => {
      currentPage.value = 1
      getTickets(true, false)
    }

    const filterTickets = () => {
      filterActive.value = !!(
        selectedAuthor.value || 
        (selectedStatus.value && selectedStatus.value.length > 0) || 
        (selectedDepartment.value && selectedDepartment.value.length > 0) ||
        selectedNumberId.value ||
        unread.value ||
        assign.value
      )
      
      currentPage.value = 1
      getTickets(true, false)
    }


    const resetFilter = () => {
      filterActive.value = false
      selectedAuthor.value = null
      selectedStatus.value = null
      selectedNumberId.value = null
      selectedDepartment.value = null
      currentPage.value = 1
      getTickets(true, false)
    }

    const populateAuthors = () => {
      let arr = []
      originalTickets.value.forEach(el => {
        let obj = {}
        obj.name = el.creator
        arr.push(obj)
      });
      authors.value = [...new Map(arr.map(item => [item['name'], item])).values()]
    }

    const populateDepartments = () => {
      let arr = []
      originalTickets.value.forEach(el => {
        let obj = {}
        obj.label = el.area
        arr.push(obj)
      });
      departments.value = [...new Map(arr.map(item => [item['label'], item])).values()]
    }



    const changeStatus = (newStatus) => {
      service.changeStatus(selectedTicket.value.id_ticket, newStatus).then((res) => {
        if (res.success) {
          getTickets(false)
          toast.add({ severity: 'success', summary: 'Successo', detail: 'Stato ticket modificato', group: 'ticket', life: 3000 });
        } else {
          toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore nella modifica stato del ticket', group: 'ticket' });
        }
      })
    }

    const assignTicket = () => {

      if (selectedTicket.value && selectedAssignUser.value) {
        loader.value = true
        service.assignTicket(selectedTicket.value.id_ticket, selectedAssignUser.value)
          .then((res) => {
            if (res.success) {
              selectedAssignUser.value = null
              getTickets(false)
              toast.add({ severity: 'success', summary: 'Successo', detail: 'Ticket assegnato', group: 'ticket', life: 3000 });
            } else {
              toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Errore assegnazione del ticket', group: 'ticket' });
            }
            dialogAssignment.value = false
          }).finally(() => {
            loader.value = false
          })
      } else {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Seleziona l\'assegnatario', group: 'ticket' });
      }
    }

    const randomColorFromString = (string) => {
      if (string && string.length > 0) {
        let hash = 0;
        for (let i = 0; i < string.length; i++) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash);
          hash = hash & hash;
        }
        let color = '#';
        for (let v = 0; v < 3; v++) {
          let value = (hash >> (v * 8)) & 255;
          color += ('00' + value.toString(16)).substr(-2);
        }
        return color;
      }
      return '#c7c7c7'
    }

    const getNumberMessagesUnread = (messages) => {
      let n = 0
      if (Object.keys(messages).length > 0) {
        for (const el of Object.values(messages)) {
          el.forEach(v => {
            if (v.read == null) {
              n++
            }
          });
        }
      }
      return n
    }


    const getNumbersTicketsAssignedNotRead = () => {
      let n = 0
      let temp = [...originalTickets.value]
      // console.log(temp);
      temp.forEach(ticket => {
        if ('id_assigned_user' in ticket && ticket.id_assigned_user != null && ticket.id_assigned_user == currentUser.value.user[0].id && String(ticket.assigned_user_type || '').toLowerCase().trim() === 'user') {
          if (Object.keys(ticket.messages).length > 0) {
            for (const el of Object.values(ticket.messages)) {
              el.forEach(m => {
                if (m.read == null) {
                  n++
                }
              });
            }
          }
        }
      })
      return n
    }


    const handleFileUpload = (evt) => {
      submitted.value = false
      const files = evt?.target?.files
      filesToUpload.value = files ? Array.from(files) : []
    }

    const downloadAttachment = (attachment) => {
      loader.value = true
      service.downloadAttachment(attachment)
        .finally(() => {
          loader.value = false
        })
    }

    const openAttachment = (attachment) => {
      loader.value = true
      service.openAttachment(attachment)
        .finally(() => {
          loader.value = false
        })
    }

    const fetchAttachmentBlob = async (attachment) => {
      return service.fetchAttachmentBlob(attachment)
    }


    const onChangeTypeRecipient = () => {
      newTicket.value.recipient = null
      selectedAssignUser.value = null
    }


    const openLinkEntity = (ticket) => {
      if (!ticket) {
        return
      }

      if ('id_entity' in ticket && ticket.id_entity) {
        window.open(`/ask/${ticket.entity_link}/${ticket.id_entity}/dettagli`, '_blank')
        return
      }

      if ('id_assigned_user' in ticket && ticket.id_assigned_user && ticket.assigned_user_type) {
        const type = String(ticket.assigned_user_type || '').toLowerCase()
        let basePath = 'clienti'

        if (type.includes('rapp')) {
          basePath = 'rappresentanti'
        } else if (type.includes('client')) {
          basePath = 'clienti'
        }

        window.open(`/ask/${basePath}/${ticket.id_assigned_user}/dettagli`, '_blank')
      }
    }

    const normalizeTicketType = (type) => String(type || '').toLowerCase().trim()

    const isClienteTicketType = (type) => {
      const normalized = normalizeTicketType(type)
      return normalized === 'client' || normalized === 'cliente' || normalized.includes('client')
    }

    const isRappresentanteTicketType = (type) => {
      return normalizeTicketType(type).includes('rapp')
    }

    const getIncallTargetFromTicket = (ticket) => {
      if (!ticket) return null

      // Rappresentante: priorità su assegnazione / entity / creatore
      if (ticket.id_assigned_user && isRappresentanteTicketType(ticket.assigned_user_type)) {
        return {
          search_type: 'rappresentante',
          search_by: 'id',
          q: String(ticket.id_assigned_user),
        }
      }

      if (ticket.id_entity && isRappresentanteTicketType(ticket.entity_type)) {
        return {
          search_type: 'rappresentante',
          search_by: 'id',
          q: String(ticket.id_entity),
        }
      }

      if (ticket.id_user && isRappresentanteTicketType(ticket.user_type)) {
        return {
          search_type: 'rappresentante',
          search_by: 'id',
          q: String(ticket.id_user),
        }
      }

      if (isRappresentanteTicketType(ticket.creator_type) && String(ticket.creator || '').trim()) {
        return {
          search_type: 'rappresentante',
          search_by: 'nome',
          q: String(ticket.creator).trim(),
        }
      }

      if (ticket.id_assigned_user && isClienteTicketType(ticket.assigned_user_type)) {
        return {
          search_type: 'cliente',
          search_by: 'id',
          q: String(ticket.id_assigned_user),
        }
      }

      if (ticket.id_entity && isClienteTicketType(ticket.entity_type)) {
        return {
          search_type: 'cliente',
          search_by: 'id',
          q: String(ticket.id_entity),
        }
      }

      if (ticket.id_user && isClienteTicketType(ticket.user_type)) {
        return {
          search_type: 'cliente',
          search_by: 'id',
          q: String(ticket.id_user),
        }
      }

      if (isClienteTicketType(ticket.creator_type) && String(ticket.creator || '').trim()) {
        return {
          search_type: 'cliente',
          search_by: 'nome',
          q: String(ticket.creator).trim(),
        }
      }

      return null
    }

    const canOpenIncall = (ticket) => {
      return !!getIncallTargetFromTicket(ticket)
    }

    const openIncall = (ticket) => {
      const target = getIncallTargetFromTicket(ticket)
      if (!target) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Impossibile aprire In Call: cliente/rappresentante non individuato sul ticket',
          group: 'ticket',
        })
        return
      }

      const ticketId = ticket?.id_ticket ?? ticket?.id
      const query = {
        search_type: target.search_type,
        q: target.q,
      }
      if (target.search_by && target.search_by !== 'nome') {
        query.search_by = target.search_by
      }
      if (ticketId) {
        query.ticket_id = String(ticketId)
        try {
          sessionStorage.setItem(
            'incall_origin_ticket',
            JSON.stringify({
              ...ticket,
              id_ticket: ticketId,
            })
          )
        } catch (e) {
          // ignore quota / private mode
        }
      }

      const url = `/in-call?${new URLSearchParams(query).toString()}`
      window.open(url, '_blank')
    }



    const validateNewTicket = () => {
      validationErrors.value = []
      if (newTicket.value.type_recipient == '')
        validationErrors.value['type_recipient'] = true;
      else
        delete validationErrors.value['type_recipient'];

      if (typeof newTicket.value.recipient === 'object' && newTicket.value.recipient !== null && ('id' in newTicket.value.recipient || 'id_ticket_area' in newTicket.value.recipient))
        delete validationErrors.value['recipient'];
      else
        validationErrors.value['recipient'] = true;

      if (newTicket.value.title == '')
        validationErrors.value['title'] = true;
      else
        delete validationErrors.value['title'];

      if (newTicket.value.content == '')
        validationErrors.value['content'] = true;
      else
        delete validationErrors.value['content'];

      if (newTicket.value.content == '')
        validationErrors.value['content'] = true;
      else
        delete validationErrors.value['content'];

      if (newTicket.value.is_related) {
        if (newTicket.value.type_entity == '')
          validationErrors.value['type_entity'] = true;
        else
          delete validationErrors.value['type_entity'];


        if (typeof newTicket.value.entity === 'object' && newTicket.value.entity !== null && 'id' in newTicket.value.entity)
          delete validationErrors.value['entity'];
        else
          validationErrors.value['entity'] = true;

      }

      if (
        requiresCallTransferArea(newTicket.value.callTransferSuccess)
        && !newTicket.value.callTransferAreaId
      ) {
        validationErrors.value['callTransferArea'] = true
      } else {
        delete validationErrors.value['callTransferArea']
      }

      return !Object.keys(validationErrors.value).length;
    }


    const validateFiles = () => {
      validationErrors.value = []
      if (filesToUpload.value.length > 0) {
        let valid = [...filesToUpload.value].every(file => Object.values(allowedType).includes(file.type), false);
        if (valid) {
          delete validationErrors.value['type'];
        } else {
          toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Formato file non supportato', group: 'ticket' });
          validationErrors.value['type'] = true;
        }

      }
      return !Object.keys(validationErrors.value).length;
    }


    provide('ticketChat', {
      selectedTicket,
      currentUser,
      moment,
      status,
      changeStatus,
      dialogAssignment,
      dialogHistoryStatus,
      dialogHistoryAssignment,
      shouldShowBloccaSospensione,
      openCheckSospensioneDialog,
      isCheckingContestazione,
      hasCallTransferInfo,
      getTicketCallTransferLabel,
      getCallTransferBadgeClass,
      openLinkEntity,
      canOpenIncall,
      openIncall,
      getInitialOfName,
      randomColorFromString,
      getNumberMessagesUnread,
      replyCallTransferSuccess,
      replyCallTransferAreaId,
      callTransferOptions,
      ticketAreas,
      onReplyCallTransferSuccessChange,
      requiresCallTransferArea,
      filesToUpload,
      keyReset,
      handleFileUpload,
      allowedType,
      newMessage,
      sendMessage,
      isSending,
      openAttachment,
      downloadAttachment,
      fetchAttachmentBlob,
    })

    return {
      dialogTicketChat,
      ticketDialogTitle,
      onTicketDialogHide,
      moment,
      filters,
      loader,
      listLoading,
      isLoaded,
      currentUser,
      sendMessage,
      createNewTicket,
      dialogNewTicket,
      dialogAssignment,
      dialogHistoryStatus,
      dialogHistoryAssignment,
      dialogBloccaSospensione,
      isBlockingSospensione,
      getTicketRecipients,
      recipients,
      typesRecipients,
      selectedAssignUser,
      recipientsAssignUser,
      newTicket,
      tickets,
      normalTickets,
      mailTickets,
      // ticketsFiltered,
      validationErrors,
      submitted,
      getContentLastMessage,
      getAssignedLabel,
      isAssignedToUser,
      isAssignedToCurrentUser,
      getInitialOfName,
      openTicket,
      isMailTicket,
      shouldShowBloccaSospensione,
      numeroFatturaContestazione,
      openCheckSospensioneDialog,
      isCheckingContestazione,
      contestazioneCheckResult,
      confirmBloccaSospensione,
      newMessage,
      isSending,
      selectedTicket,
      randomColorFromString,
      getNumberMessagesUnread,
      searchString,
      search,
      status,
      selectedDepartment,
      departments,
      getNumbersTicketsAssignedNotRead,
      unread,
      assign,
      areaAssignedOnly,
      onAreaAssignedOnlyChange,
      changeStatus,
      assignTicket,
      filterTickets,
      authors,
      selectedAuthor,
      selectedStatus,
      selectedNumberId,
      filterActive,
      resetFilter,
      filesToUpload,
      keyReset,
      type_assign_recipient,
      onChangeTypeRecipient,
      typesEntity,
      getTicketEntity,
      entity,
      openLinkEntity,
      canOpenIncall,
      openIncall,
      allowedType,
      handleFileUpload,
      downloadAttachment,
      openAttachment,
      totalTickets,
      unreadTicketsTotal,
      getTickets,
      currentPage,
      perPage,
      onPageChange,
      ticketAreas,
      callTransferOptions,
      replyCallTransferSuccess,
      replyCallTransferAreaId,
      requiresCallTransferArea,
      onCallTransferSuccessChange,
      onReplyCallTransferSuccessChange,
      hasCallTransferInfo,
      getTicketCallTransferLabel,
      getCallTransferBadgeClass,
    }
  }
}
</script>

<style>
.chat .messages-chat .p-divider-content {
  text-transform: uppercase;
  color: #bbbbbb;
  font-size: 12px;
  background-color: #edf1f5 !important;
  z-index: 0;
}

.discussion .option {
  width: 100%;
}

.discussion .option .p-accordion-toggle-icon {
  font-size: 9px;
}

.discussion .option .p-accordion-header-text {
  font-size: 11px;
}

.discussion .option .p-accordion-header-link {
  padding: 0.4rem 1rem !important;
  border: none;

}

.discussion .option .p-accordion-header-link:focus {
  outline: none !important;
}

.searchbar .p-inputtext:focus {
  outline: none !important;
  outline-style: none;
  box-shadow: none;
  border-color: transparent;
}

.chat .header-chat #assign {
  border: none;
  background: none;
  margin-top: -10px;
}

.chat .header-chat #assign .p-dropdown-label {
  color: var(--primary-color);
}

.chat .header-chat #assign .p-dropdown-trigger {
  display: none !important;
}
</style>

<style scoped>
.container {
  padding: 0;
  background-color: #FFF;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  height: 700px;
}

input {
  outline: none;
}

/* === CONVERSATIONS === */
.discussions::-webkit-scrollbar-track,
.chat::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background: #e9e9e9;
}

.discussions::-webkit-scrollbar-thumb,
.chat::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
}

.discussions::-webkit-scrollbar,
.chat::-webkit-scrollbar {
  width: 6px;
}

.tickets-sidebar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  height: calc(100vh - 6em);
}

.discussions {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  /* fix valentina */
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.20);
  overflow: hidden;
  overflow-y: scroll;
  position: relative;
}

.filter-tickets--embedded .p-accordion-header-link {
  padding: 0.65rem 0.9rem;
}

.filter-tickets--embedded .p-accordion-content,
.filter-tickets--embedded .p-accordion-content-content {
  overflow: visible;
}

.filter-tickets--embedded .p-accordion-content {
  padding: 0.85rem 0.9rem 0.7rem;
}

.filter-tickets-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.75rem 0.85rem;
}

.filter-tickets-field {
  min-width: 0;
}

.filter-tickets-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
  color: #334155;
}

.filter-tickets-actions {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
}

.filter-tickets-actions .p-button {
  min-width: 7.5rem;
}

.discussions .search.search--embedded {
  height: auto;
  min-height: 64px;
  padding: 0;
}

.ticket-toolbar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem 0.55rem;
}

.discussions .search.search--embedded .ticket-toolbar .searchbar {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  height: 40px;
  padding: 0 14px;
}

.ticket-toolbar-check {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  margin: 0;
  font-size: 12px;
  line-height: 1.2;
  color: #515151;
  white-space: nowrap;
  cursor: pointer;
}

.ticket-toolbar-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.ticket-toolbar-icon .pi {
  margin-left: 0;
  color: rgb(149, 149, 149);
  font-size: 18px;
}

.ticket-toolbar-icon .pi.ticket-unread-eye {
  font-size: 22px;
}

.ticket-toolbar-icon .pi.text-primary {
  color: #2196f3;
}

.tickets-embedded {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.tickets-embedded > .grid {
  flex: 1 1 auto;
  min-height: 0;
  margin: 0;
}

.tickets-embedded .tickets-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.discussions--embedded {
  flex: 1 1 auto;
  height: auto;
  max-height: none;
  min-height: 0;
}

.tickets-sidebar:has(.discussions--embedded) {
  height: 100%;
}


.discussions-loader {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    236deg,
    rgba(255, 255, 255, 0.92) 0%,
    rgba(255, 255, 255, 0.65) 100%
  );
}

.discussions-loader-spinner {
  width: 48px;
  height: 48px;
  display: inline-block;
  border-width: 2px;
  border-style: solid;
  border-color: #2196f3;
  border-top-color: transparent;
  border-radius: 100%;
  animation: discussions-spin 0.6s infinite linear;
}

@keyframes discussions-spin {
  100% {
    transform: rotate(360deg);
  }
}

.ticket-chat-dialog-body {
  min-height: 420px;
}

.discussions .discussion {
  position: relative;
  width: 100%;
  height: 108px;
  padding: 18px 8px 16px 0;
  box-sizing: border-box;
  background-color: #FAFAFA;
  border-top: solid 1px #E0E0E0;
  display: flex;
  align-items: center;
  overflow: hidden;
}


/* Sezione mail: fuori da .discussions, layout indipendente */
.mail-tickets-section {
  flex: 0 0 auto;
  max-height: 220px;
  display: flex;
  flex-direction: column;
  border: 1px solid #93c5fd;
  border-radius: 10px;
  background: #f0f7ff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
  overflow: hidden;
}

.mail-tickets-section--embedded {
  max-height: 180px;
}

.mail-tickets-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  background: #dbeafe;
  border-bottom: 1px solid #93c5fd;
}

.mail-tickets-section__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #1e40af;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.mail-tickets-section__title .pi {
  font-size: 13px;
}

.mail-tickets-section__count {
  min-width: 22px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #fff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.mail-tickets-section__list {
  overflow-y: auto;
  background: #f8fbff;
}

.mail-ticket-row {
  display: block;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #dbeafe;
  background: transparent;
  text-align: left;
  padding: 10px 14px;
  cursor: pointer;
  color: inherit;
}

.mail-ticket-row:last-child {
  border-bottom: 0;
}

.mail-ticket-row:hover {
  background: #e8f2ff;
}

.mail-ticket-row--active {
  background: #dbeafe;
}

.mail-ticket-row--unread .mail-ticket-row__title {
  font-weight: 700;
}

.mail-ticket-row__top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.mail-ticket-row__id {
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
}

.mail-ticket-row__chip {
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #1d4ed8;
  background: #bfdbfe;
}

.mail-ticket-row__status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: auto;
}

.mail-ticket-row__status-label {
  font-size: 10px;
  color: #64748b;
}

.mail-ticket-row__title {
  font-size: 13px;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.mail-ticket-row__meta {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.mail-ticket-row__excerpt {
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.discussions *:not(.search) {
  cursor: pointer;
}

.discussions .search {
  display: block;
  z-index: 1;
  color: #E0E0E0;
  position: sticky;
  top: 0;
  height: 70px;
  padding: 0;
  overflow: visible;
}

.discussions .search .searchbar {
  height: 40px;
  background-color: #FFF;
  width: 70%;
  padding: 0 20px;
  border-radius: 50px;
  border: 1px solid #EEEEEE;
  display: flex;
  align-items: center;

}

.discussions .search .searchbar input {
  margin-left: 15px;
  height: 38px;
  width: 100%;
  border: none;
}

.discussions .search .searchbar *::-webkit-input-placeholder {
  color: #E0E0E0;
}

.discussions .search .searchbar input *:-moz-placeholder {
  color: #E0E0E0;
}

.discussions .search .searchbar input *::-moz-placeholder {
  color: #E0E0E0;
}

.discussions .search .searchbar input *:-ms-input-placeholder {
  color: #E0E0E0;
}

.area-assigned-only-label {
  margin-left: 8px;
  font-size: 11px;
  line-height: 1.2;
  color: #515151;
  cursor: pointer;
}

.discussion .new-ticket i {
  color: rgb(149, 149, 149);
  font-size: 18px;
  margin-left: 12px;
}

.discussion .new-ticket i.ticket-unread-eye {
  font-size: 22px;
}

.discussion .new-ticket-assigned {
  position: absolute;
  top: -15px;
  right: -12px;
  width: 25px;
  height: 25px;
  padding-bottom: 2px;
  background-color: #d558ad;
  border-radius: 13px;
  border: 3px solid #FAFAFA;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.discussions .ticket-toolbar-icon .new-ticket-assigned {
  top: -4px;
  right: -8px;
}

.discussions .ticket-read .discussion {
  /* opacity: 0.65; */
}

.discussion .volume {
  width: 12px;
  color: rgb(149, 149, 149);
}

.discussions .message-active {
  background-color: #FFF;
  border-right: 4px solid #00e3de;
}

.discussions .discussion .badge-name {
  position: relative;
  margin-left: 20px;
  display: block;
  width: 45px;
  min-width: 45px;
  height: 45px;
  /* background: #d5d5d5; */
  border: 1px solid rgba(51, 51, 51, 0.13);
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  font-size: 16px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}


.desc-contact {
  flex: 1;
  min-width: 0;
  height: auto;
  width: auto;
  max-width: none;
  padding-right: 72px;
  overflow: hidden;
}

.desc-contact .name,
.desc-contact .message,
.desc-contact .assigned-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-number {
  position: absolute;
  top: 0px;
  right: 35px;
  width: 25px;
  height: 25px;
  padding-bottom: 2px;
  background-color: #8BC34A;
  border-radius: 13px;
  border: 3px solid #FAFAFA;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.badge-assignment {
  position: absolute;
  top: 0px;
  left: 35px;
  width: 25px;
  height: 25px;
  padding-bottom: 2px;
  background-color: #d558ad;
  border-radius: 13px;
  border: 3px solid #FAFAFA;
  font-size: 10px;
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.badge-assignment .pi {
  font-size: 9px;
}

.discussions .discussion .name {
  margin: 0 0 0 20px;
  font-size: 11pt;
  color: #515151;
  font-weight: 500;
}

.discussion .id-number {
  position: absolute;
  font-size: 9px;
  top: 4px;
  left: 8px;
  text-transform: uppercase;
  color: #b5b5b5;
}

.discussion .area {
  position: absolute;
  font-size: 10px;
  bottom: 4px;
  left: 8px;
  text-transform: uppercase;
  color: #b5b5b5;
}

.discussion .creator {
  position: absolute;
  font-size: 8px;
  top: 4px;
  right: 10px;
  max-width: 46%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  z-index: 2;
}

.discussion .creator .type {
  font-size: 7px !important;
  margin-left: 4px !important;

}

.discussions .discussion .message {
  margin: 4px 0 0 20px;
  font-size: 9pt;
  color: #515151;
}

.discussions .discussion .assigned-line {
  margin: 4px 0 0 20px;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  color: #0d3c61;
}

.discussions .discussion .status {
  position: absolute;
  right: 22px;
  bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.discussions .discussion .status .icon {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 5px;
}

.discussions .discussion .status .text {
  font-size: 9px;
}


.chat {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 12em);
  /*fix valentina */
}

.header-chat {
  background-color: #FFF;
  height: 90px;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.100);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  /* display:flex;
  align-items: center;
  justify-content: space-between; */
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;
}

.chat .header-chat .icon {
  margin-left: 30px;
  margin-right: 30px;
  color: #515151;
  font-size: 14pt;
}

.chat .header-chat .name {
  margin: 0 0 0 20px;
  text-transform: uppercase;
  font-size: 13pt;
  color: #515151;
}

.chat .header-chat small {
  font-size: 10px;
  text-transform: uppercase;
}

.chat .header-chat .id-number {
  text-transform: uppercase;
  color: #b5b5b5;
}

.chat .header-chat .title {
  font-size: calc(0.4vw + 0.5vh + 0.1vmin);
  font-weight: bold;
}

.chat .header-chat .status {

  color: var(--primary-color);
}

.chat .header-chat .history {
  margin-top: -14px;
}

.chat .header-chat .assign {
  font-size: 12px;
  color: var(--primary-color);
}



.chat .header-chat .circle-status {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 5px;
}

.chat .header-chat .status .text {
  font-size: 12px;
}

/* .chat .header-chat .manage-from{
  position: absolute;
  top: 8px;
  left: 8px;
  text-transform: lowercase;
  font-size: 12px;
}

.chat .header-chat .manage-from span{
  font-weight: bold;
  text-transform: uppercase;
  font-size: 13px;
} */

.chat .messages-chat {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 25px;
}



.chat .messages-chat .message {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.chat .messages-chat .message .badge-name {
  display: block;
  width: 45px;
  min-width: 45px;
  height: 45px;
  /* background: #d5d5d5; */
  border: 1px solid rgba(51, 51, 51, 0.13);
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  font-size: 16px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat .messages-chat .text {
  margin: 0 20px;
  background-color: #f6f6f6;
  padding: 15px;
  border-radius: 12px;
  white-space: pre-wrap;
}

.chat .messages-chat .sticky-date {
  position: sticky;
  top: 160px;
}

.chat .messages-chat .sticky-date::before {
  border-top: none !important;
}


.text-only {
  margin-left: 45px;
}

.time {
  font-size: 10px;
  color: lightgrey;
  margin-bottom: 10px;
  margin-left: 85px;
}

.response-time {
  display: flex;
  justify-content: right;
  margin-right: 40px !important;
}

.response {
  float: right;
  margin-right: 0px !important;
  margin-left: auto;
  /* flexbox alignment rule */
}

.response .text {
  background-color: #e3effd !important;
}

.footer-chat {
  width: 100%;
  flex-shrink: 0;
  background-color: #f4f6f8;
  border-top: 1px solid #e3e7ec;
  padding: 0.7rem 1rem 0.85rem;
}

.footer-chat-inner {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  width: 100%;
}

.footer-chat-transfer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.85rem;
  padding: 0.5rem 0.65rem;
  background: #fff;
  border: 1px solid #e5e9ef;
  border-radius: 10px;
}

.footer-chat-transfer-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 220px;
  min-width: 0;
}

.footer-chat-transfer-item label {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
}

.footer-chat-transfer-item .footer-chat-dropdown,
.footer-chat-transfer-item .p-dropdown {
  flex: 1;
  min-width: 0;
}

.footer-chat-compose {
  display: flex;
  align-items: flex-end;
  gap: 0.55rem;
  padding: 0.45rem 0.55rem;
  background: #fff;
  border: 1px solid #e5e9ef;
  border-radius: 12px;
}

.footer-chat-attach {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
}

.footer-chat-attach .pi-paperclip {
  font-size: 1.35rem;
}

.footer-chat-input {
  flex: 1;
  min-width: 0;
}

.footer-chat-send {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.chat .footer-chat .badge-file {
  position: absolute;
  top: -2px;
  right: -10px;
}

.chat .footer-chat .icon {
  margin-left: 10px;
  color: #C0C0C0;
  font-size: 14pt;
}

.chat .footer-chat .send {
  color: #fff;
  background-color: var(--primary-color);
  padding: 14px 14px 12px 12px;
  border-radius: 50px;
  font-size: 12pt;
}

.chat .footer-chat .send:hover {
  background-color: #00ecdc;
}

.chat .footer-chat .ask-send {
  transform: rotate(90deg);
}

.chat .footer-chat .name {
  margin: 0 0 0 20px;
  text-transform: uppercase;
  font-size: 13pt;
  color: #515151;
}

.chat .footer-chat .right {
  position: absolute;
  right: 40px;
}

.write-message {
  border: none !important;
  width: 100%;
  min-height: 42px;
  max-height: 120px;
  margin: 0;
  padding: 0.45rem 0.2rem;
  outline: none;
  background: transparent;
  box-shadow: none !important;
  resize: none;
}

.footer-chat .write-message.p-inputtextarea {
  overflow-y: auto !important;
}

.footer-chat .footer-chat-dropdown.p-dropdown,
.footer-chat .footer-chat-transfer-item .p-dropdown {
  width: 100%;
  min-height: 2.1rem;
  border-color: #dfe5ec;
}

.footer-chat .footer-chat-dropdown .p-dropdown-label,
.footer-chat .footer-chat-transfer-item .p-dropdown-label {
  padding: 0.4rem 0.65rem;
  font-size: 0.84rem;
}

.footer-chat .footer-chat-dropdown .p-dropdown-trigger,
.footer-chat .footer-chat-transfer-item .p-dropdown-trigger {
  width: 2rem;
}


.footer-chat *::-webkit-input-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
}

.footer-chat input *:-moz-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
}

.footer-chat input *::-moz-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
  margin-left: 5px;
}

.footer-chat input *:-ms-input-placeholder {
  color: #C0C0C0;
  font-size: 13pt;
}

.clickable {
  cursor: pointer;
}

.chat::v-deep .box-unread {
  display: flex;
  justify-content: center;
  margin: 20px 10px;
  background: white;
  color: #d5d5d5;
  padding: 5px;
}

.button-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

#upload {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.chat .attachments .attachment {
  cursor: pointer;
  background-color: #e3e3e3;
  padding: 12px;
  border-radius: 12px;
}

.chat .attachments div[class^='col'] {
  display: flex;
  align-items: center;
}

.pagination-container {
  padding: 1rem;
  background-color: #FAFAFA;
  border-top: solid 1px #E0E0E0;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.block-sospensione-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
}

.call-transfer-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
}

.call-transfer-badge--success {
  color: #166534;
  background: #ecfdf3;
}

.call-transfer-badge--failed {
  color: #b91c1c;
  background: #fef2f2;
}

.ticket-message-transfer {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.45rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}
</style>
